export type FileData = {
  base64: string
  type: string
  name: string
  size: number
}

export const convertFileToBase64 = (file: File): Promise<FileData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const result = reader.result as string
      const base64 = result.split(',')[1] // Убираем префикс data:type;base64,

      resolve({
        base64,
        type: file.type,
        name: file.name,
        size: file.size,
      })
    }

    reader.onerror = () => {
      reject(new Error('Ошибка при чтении файла'))
    }

    reader.readAsDataURL(file)
  })
}

export const validateFile = (file: File, pdfOnly = false): string | undefined => {
  const allowedTypes = pdfOnly
    ? ['application/pdf']
    : ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']

  const maxSize = 15 * 1024 * 1024 // 15MB

  if (!allowedTypes.includes(file.type)) {
    return pdfOnly
      ? 'Можно прикрепить только файл в формате PDF'
      : 'Разрешены только изображения (JPG, PNG) и PDF файлы'
  }

  if (file.size > maxSize) {
    return 'Размер файла не должен превышать 15MB'
  }

  return undefined
}
